/* eslint-disable require-jsdoc */
import {
    GTM_SELECTOR_PRODUCT_LIST_VIEW,
    GTM_ATTRIBUTE_PAGE_READY,
    GTM_ATTRIBUTE_PRODUCT_LIST_OBSERVER,
} from '../helpers/gtm/gtmSelectors';
import {gtmProductListView} from '../helpers/gtm/gtmProductListView';
import {gtmProductsClickInit} from '../helpers/gtm/gtmProductsClickInit';

const gtmProductListInit = (rootElementSelector) => {
    const rootElement = rootElementSelector ? document.querySelector(rootElementSelector) ?? document : document;
    function handleVisibilityChange(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                gtmProductListView(entry.target, entry.target.dataset.gtmProductListView);
                if (!entry.target.dataset?.gtmProductsClickInit) {
                    gtmProductsClickInit(entry.target, entry.target.dataset.gtmProductListView);
                    entry.target.setAttribute('data-gtm-products-click-init', true);
                }
            }
        });
    }

    const observer = new IntersectionObserver(handleVisibilityChange, {
        root: null,
        rootMargin: '99999px 0px 99999px 0px',
        threshold: 0,
    });

    rootElement.querySelectorAll(GTM_SELECTOR_PRODUCT_LIST_VIEW).forEach((productList) => {
        observer.observe(productList);
    });
};

const initOnGTMProductListUpdate = () => {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' &&
                (mutation.attributeName === GTM_ATTRIBUTE_PRODUCT_LIST_OBSERVER ||
                mutation.attributeName === GTM_ATTRIBUTE_PAGE_READY)
            ) {
                if (document.body.dataset?.gtmPageReady) {
                    const rootElementSelector = mutation.target.dataset.gtmProductListObserver;
                    gtmProductListInit(rootElementSelector);
                }
            }
        }
    });

    observer.observe(document.body, {attributes: true});
};

const triggerGtmProductsObserver = (rootElement) => {
    document.body.setAttribute(GTM_ATTRIBUTE_PRODUCT_LIST_OBSERVER, rootElement);
};

window.sga.triggerGtmProductsObserver = triggerGtmProductsObserver;

//EX-1229
// initOnGTMProductListUpdate();
